import { useTranslation } from 'react-i18next';
import PaginaTexto from '../Compartido/PaginaTexto.jsx';

const TextosPoliticaPrivacidad = ({ ruta, politicaprivacidad }) => {

    const { t } = useTranslation();

    return (
        <PaginaTexto
            titulo={t("Política de privacidad")}
            eyebrow={t("Legal")}
            imagen={politicaprivacidad.imagen_cabecera ? ruta + "/" + politicaprivacidad.imagen_cabecera : null}
            html={politicaprivacidad.ladesc}
        />
    );
}

export default TextosPoliticaPrivacidad;
